import React from "react";
import { Link } from "react-router-dom";
import { makeStyles, Tooltip } from "@material-ui/core";

// @material-ui icons
import OpenWith from "@material-ui/icons/PhotoSizeSelectActualOutlined";
import CheckedBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineIcon from "@material-ui/icons/CheckBoxOutlineBlank";

// core components
import Button from "core/components/CustomButtons/Button.js";

import styles from "core/assets/jss/material-dashboard-pro-react/views/utilitiesStyle.js";
const useStyles = makeStyles(styles);

export function Action(props) {
	const classes = useStyles();
  const { tooltip="Click button to perform action", placement="top", 
          color="info", simple=true } = props;
	return (
    <Tooltip id={ props.id ? props.id + ".tooltip" : undefined } 
              title={tooltip} placement={placement}
              classes={{ tooltip: classes.tooltip }}>
      <Button justIcon={!simple} simple={simple} color={color} 
        {...props} className={classes.actionButton}>
          { props.icon ?
            <props.icon className={classes.icon} /> :
            <OpenWith className={classes.icon} /> }
      </Button>
    </Tooltip>
	);
}

export function TableCheckBox(props) {
  const [checked, setChecked] = React.useState(props.checked);
	const classes = useStyles();
	return (
    <Button simple color={checked ? "primary" : "transparent"}
            {...props} 
            onClick={() => {
              setChecked(!checked)
              props.onClick(checked)
            }}
            className={classes.actionButton}>
      {checked ? (<CheckedBoxIcon className={classes.largeicon} />) : 
                  (<CheckBoxOutlineIcon className={classes.largeicon} />)}
    </Button>
	);
}

export const makeLink = (display, path, state={}, queryParams='') => {
  const segment = window.location.pathname.endsWith("/") ? path : "/" + path;
	return (
		<div>
			<Link to={{pathname: window.location.pathname + segment, search: queryParams, state: state}}>
				{display}
			</Link>
		</div>
	);
}

export function HRef(props) {
  const { display, href } = props;
  const classes = useStyles();
  return (
    <div>
      <a href={href}><props.icon className={classes.icon}/></a> {display}
    </div>
  )
}

export * from "core/utils/utilities";